import axios from "axios";

const baseURL = process.env.REACT_APP_HEC_API_BASE_URL;

if (!baseURL) {
  console.error(
    "REACT_APP_HEC_API_BASE_URL is not set; Experiment Pass requests will fail."
  );
}

// Research Platform (RP) API client. It must NOT carry the ORSEE participant token:
// that credential belongs to ORSEE, and RP authenticates its own users (Sanctum).
const hecApiInstance = axios.create({
  baseURL,
  headers: {
    post: {
      "Content-Type": "application/json",
    },
  },
});

export default hecApiInstance;
